import React from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DrawerTitleProps } from "../types";

function DrawerTitle({ className, ...props }: DrawerTitleProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <DrawerPrimitive.Title
      data-slot="drawer-title"
      className={cn(
        "text-lg font-semibold leading-none tracking-tight",
        className,
        classes,
      )}
      {...native}
    />
  );
}

DrawerTitle.displayName = "Drawer.Title";

export default DrawerTitle;
